import { render, staticRenderFns } from "./batchCirculation.vue?vue&type=template&id=15606bde&scoped=true"
import script from "./batchCirculation.vue?vue&type=script&lang=js"
export * from "./batchCirculation.vue?vue&type=script&lang=js"
import style0 from "./batchCirculation.vue?vue&type=style&index=0&id=15606bde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15606bde",
  null
  
)

export default component.exports